import React from 'react';
import { COLORS, Image, ImageEntity, SIZES, Typography } from '@fupa/fupa-uikit';
import { desktopContentWidth, streamModuleBreakpointLarge } from 'app/styles/media';
import styled from 'styled-components';
import { LinkOnComponent } from 'app/components/links/link';
import { ClampedLineSubtitle, ClampedLineTitle, ComponentWrapper, ImageContainer, TextContainer } from 'app/components/competitionModule/news/commonStyles';
const RelativeDateContainer = styled.div.withConfig({
  componentId: "sc-g0q6fr-0"
})(["position:absolute;bottom:0;left:0;width:100%;padding:", " ", " ", ";background:linear-gradient(0deg,rgba(0,0,0,0.8) 0%,rgba(0,0,0,0) 100%);text-align:end;"], SIZES['16'], SIZES['4'], SIZES['4']);
const WhiteTypography = styled(Typography).withConfig({
  componentId: "sc-g0q6fr-1"
})(["&&&{color:", ";}"], COLORS.white);
export default function CompetitionModuleNewsComponent(_ref) {
  let {
    data
  } = _ref;
  return /*#__PURE__*/React.createElement(LinkOnComponent, {
    to: data.getLink(),
    "data-sentry-element": "LinkOnComponent",
    "data-sentry-component": "CompetitionModuleNewsComponent",
    "data-sentry-source-file": "CompetitionModuleNewsComponent.tsx"
  }, /*#__PURE__*/React.createElement(ComponentWrapper, {
    "data-sentry-element": "ComponentWrapper",
    "data-sentry-source-file": "CompetitionModuleNewsComponent.tsx"
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    "data-sentry-element": "ImageContainer",
    "data-sentry-source-file": "CompetitionModuleNewsComponent.tsx"
  }, /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.News,
    src: data.news.image,
    ratio: "1:1",
    sizesHint: "(min-width: ".concat(desktopContentWidth, "px) 120px, (min-width: ").concat(streamModuleBreakpointLarge, "px) 160px, 100px}"),
    "data-sentry-element": "Image",
    "data-sentry-source-file": "CompetitionModuleNewsComponent.tsx"
  }), /*#__PURE__*/React.createElement(RelativeDateContainer, {
    "data-sentry-element": "RelativeDateContainer",
    "data-sentry-source-file": "CompetitionModuleNewsComponent.tsx"
  }, /*#__PURE__*/React.createElement(WhiteTypography, {
    variant: "caption1",
    "data-sentry-element": "WhiteTypography",
    "data-sentry-source-file": "CompetitionModuleNewsComponent.tsx"
  }, data.formatDateRelative()))), /*#__PURE__*/React.createElement(TextContainer, {
    "data-sentry-element": "TextContainer",
    "data-sentry-source-file": "CompetitionModuleNewsComponent.tsx"
  }, /*#__PURE__*/React.createElement(ClampedLineTitle, {
    "data-sentry-element": "ClampedLineTitle",
    "data-sentry-source-file": "CompetitionModuleNewsComponent.tsx"
  }, data.news.title), /*#__PURE__*/React.createElement(ClampedLineSubtitle, {
    "data-sentry-element": "ClampedLineSubtitle",
    "data-sentry-source-file": "CompetitionModuleNewsComponent.tsx"
  }, data.subtitle))));
}